/**
 *
 * UserListItem
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// antd component
import { List } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';
// utils
import { USER_TYPES_OPTIONS } from 'utils/helpers/helper.constant';

function UserListItem({
  element,
  searchString,
  // formats
  timeFormat,
  dateFormat,
  // func
  customHighlighter,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('user-list-meta', className);
  const { t } = useTranslation();

  const userName = `${element?.description?.lastname} ${element?.description?.firstname}`;
  
  return element && (
    <List.Item.Meta
    className={childClassNames}
      title={customHighlighter(userName, searchString)}
      description={
        <>
          <span className="user-role">
            <CustomIcons type="person" />
            {customHighlighter(USER_TYPES_OPTIONS(element?.role), searchString)}
          </span>
        </>
      }
    />
  );

};

UserListItem.defaultProps = {
  dateFormat: 'DD.MM.YYYY',
  timeFormat: 'HH:mm',
};
UserListItem.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  searchString: PropTypes.string,
  customHighlighter: PropTypes.func.isRequired,
};

export default memo(UserListItem);